import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Button } from '@components/main-components/button/Button';
import { DataTestId } from '@utils/test';

export const MarketplaceButton = ({
  label,
  link,
  fullWidth,
  onClick,
  size = 'XL',
}: {
  label: string;
  link?: string;
  fullWidth: boolean | undefined;
  onClick?: () => void;
  size?: React.ComponentProps<typeof Button>['size'];
}) => {
  return (
    <Button
      data-testId={DataTestId.RELEASE_PAGE_MARKETPLACE_BUTTON}
      href={link}
      variant="primary"
      size={size}
      label={label}
      trailingIcon={<FontAwesomeIcon icon={faArrowUpRight} fontSize={18} />}
      fullWidth={fullWidth}
      onClick={onClick}
    />
  );
};
